module.exports = __webpack_public_path__ + "static/media/map-marker.43af5955.svg";